import React, { memo, useEffect, useState } from "react";
import { EyesIcon, LikeFillIcon, LikeIcon, ShareIcon } from "@t8891/icon";
import { IBuyCarMenuList } from "@Types/buyCarMenu";
import { formatThousend } from "../../utils/helper";
import ShareItem from "./ShareItem";
import { useSessionStorageState } from "ahooks";
import QuestionForm from "./QuestionForm";

const CardItem: React.FC<
  { item: IBuyCarMenuList["list"][0] } & {
    likeList: any;
    index: number;
    source: string;
    gaId: string;
    itemsStyle?: React.CSSProperties;
    titleStyle?: React.CSSProperties;
    updateViewStatus: (id) => void;
    viewed: number[];
    params: any;
    clickLikeItem: (id: number) => Promise<boolean>;
  }
> = ({
  item,
  index,
  likeList,
  viewed,
  updateViewStatus,
  clickLikeItem,
  itemsStyle,
  titleStyle,
  source = "購車菜單-列表-徵求菜單",
  gaId,
  params,
}) => {
  const { id, brandName, kindName, modelName, postDate, details, tag, detailLink } = item;
  const {
    type,
    price,
    date,
    equip,
    priceRemark,
    views,
    isCheck,
    assignIntro,
    seekedNum,
    shares,
    isRecommend,
    subType,
    dealStatus,
  } = details;
  const { page } = params;

  const [likeCount, setLikeCount] = useState(details?.likeCount || 0);
  // 解决请求时延导致重复点赞
  const [liked, setLiked] = useState(false);

  const isLike = !!likeList?.[id];

  const handleLike = async (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    e.preventDefault();
    if (isLike) return;
    if (liked) return;
    const result = await clickLikeItem(id);
    //  点赞失败
    if (!result) return;
    const count = likeCount + 1;
    setLikeCount(count);
    setLiked(true);
  };

  useEffect(() => {
    // 数据更新时更新点赞状态
    if (id) {
      setLiked(false);
    }
  }, [id]);

  useEffect(() => {
    setLikeCount(details?.likeCount);
  }, [details?.likeCount]);

  return (
    <>
      <a
        href={`/buycar/menu/${id}`}
        id={`CardItem${type}`}
        className={`${
          gaId ? gaId : ""
        } block w-930 mb-20 rounded-4 relative text-28 text-black pb-14 mx-auto hover:box-shadow`}
        target='_blank'
        style={{
          border: "1px solid #E8E8E8",
          background: !!dealStatus ? "linear-gradient(90deg,#ffffff 50%, #ffdfdf)" : "#fff",
          ...itemsStyle,
        }}
        onClick={() => {
          updateViewStatus(id);
        }}
      >
        {/* 微整求着已成功图案 */}
        {!!dealStatus && (
          <img
            className='absolute w-100 h-80 right-42 bottom-0'
            src={`https://photo.8891.com.tw/2025/01/14/1736836433523585.png`}
            alt="icon"
            width={100}
            height={80}
            loading="eager"
          />
        )}
        <div className='flex justify-between h-30'>
          <div className={`w-98 h-30 -mt-5`}>
            <img
              className='w-98'
              alt="icon"
              width={98}
              height={30}
              loading="eager"
              src={
                type === 2
                  ? "https://assets.8891.com.tw/images/menu_share_icon.png"
                  : "https://assets.8891.com.tw/images/menu_share_icon_x3.png"
              }
            />
          </div>
          <div className={`text-[#999999] text-12 items-center flex h-46`}>
            <span className='-mt-14'>發佈時間{postDate}</span>
            <div className='mr-10' />
            {!!isRecommend && (
              <img className='w-48 h-44 z-0' src='https://photo.8891.com.tw/2024/11/27/1732669853737495.png' alt="icon" width={48} height={44} loading="eager" />
            )}
          </div>
        </div>
        <div className='mt-6 text-20 text-black font-semibold leading-normal px-20' style={{ ...titleStyle }}>
          <span className={`mr-10 ${viewed?.includes?.(id) ? "text-[#bbb]" : ""}`}>
            {brandName} {kindName} {modelName}
          </span>
          {isCheck === 1 && (
            <img className='w-[118px] h-20 -mt-3' src='https://photo.8891.com.tw/2024/08/05/1722843092820728.png' alt="icon" width={118} height={20} loading="eager" />
          )}
        </div>
        <div className='text-14 flex justify-between px-20'>
          <div>
            {tag?.length > 0 && (
              <div className='flex gap-10 mt-14 flex-wrap'>
                {tag.map((item: any, index: number) => {
                  const showHighLightTag = ["特殊車"];
                  const isTrue = showHighLightTag.includes(item);
                  const specialClassName = isTrue ? "bg-[#EAEFFF]" : "bg-[#F5F5F5]";

                  return (
                    <div
                      className={`px-12 h-28 rounded-4 flex items-center justify-center text-14 whitespace-pre  text-[#666] ${specialClassName}`}
                      key={index}
                    >
                      {item}
                    </div>
                  );
                })}
              </div>
            )}

            <div className='flex gap-5 mt-18'>
              <div className='text-[#999] w-56 mr-12' style={{ textAlignLast: "justify" }}>
                {type === 1 ? (subType === 2 ? "詢價" : "下訂") : "購車時間"}
              </div>
              {date || "--"}
            </div>
            {!!equip && (
              <div className='flex gap-5 mt-14 leading-20'>
                <div className='text-[#999] w-56 mr-12' style={{ textAlignLast: "justify" }}>
                  配備
                </div>
                <div className='line-clamp-1 w-400 text-black' dangerouslySetInnerHTML={{ __html: equip }} />
              </div>
            )}
          </div>

          <div className='flex justify-between gap-40 items-center mr-10 relative'>
            <div className='w-200'>
              <div className='text-[#333] mb-8 text-12 w-full justify-center flex'>
                {type === 1 ? "成交價" : "預算"}
              </div>
              <div className={`flex items-center font-normal text-14 justify-center mt-4`}>
                <span className='text-[#FF4433] text-24 font-semibold'>{price}</span>
              </div>
              <div
                className={`justify-center flex items-center font-normal text-12 text-[#999999] mt-8 whitespace-pre`}
              >
                {priceRemark}
              </div>
            </div>
            <div
              className='w-120 h-44 bg-primary rounded-4  flex items-center justify-center text-white bg-[#3264FF] text-16 flex-col z-1 relative'
              data-type={type == 2 ? "徵求菜單" : "分享菜單"}
              onClick={(e) => {
                e.preventDefault();
                window.open(`/buycar/postMenu?id=${id}&type=2&source=${source}`, "_blank");

                handleLike(e);
              }}
            >
              徵求此菜單
              {!!seekedNum && (
                <div className='text-12 text-white leading-14'>
                  <span className='text-[#FFEA01]'>{seekedNum}</span>
                  人徵求
                </div>
              )}
            </div>
          </div>
        </div>
        <div className='text-14 mt-14 px-20 flex gap-20'>
          <div className='flex items-center'>
            {type === 2 ? (
              <div className='flex items-center mt-2' dangerouslySetInnerHTML={{ __html: assignIntro }}></div>
            ) : (
              <div
                className='flex items-center gap-4'
                onClick={(e) => {
                  handleLike(e);
                }}
              >
                {isLike ? <LikeFillIcon size={20} fill='#3264ff' /> : <LikeIcon size={20} fill='#333' />}
                {likeCount > 0 && (
                  <div>
                    <span className='text-[#FF4433]'>{likeCount}</span>人按讚
                  </div>
                )}
                好菜單！
              </div>
            )}
          </div>
          {/* <ShareItem link={detailLink} data={shares} id={id} /> */}
          <div className='flex gap-4 items-center'>
            <EyesIcon size={48} fill='#333' />
            {!!views ? formatThousend(views) : 1}人瀏覽
          </div>
        </div>
      </a>
      {Number(page) === 1 && index === 2 && <QuestionForm />}
    </>
  );
};

const MenuList: React.FC<any> = ({ data, containtStyle, itemsStyle, titleStyle, ...itemProps }) => {
  // 是否瀏覽過
  const [viewed, updateViewStatus] = useSessionStorageState<any>("menu-view", { defaultValue: [] });
  return (
    <div className='w-930' style={containtStyle ? containtStyle : {}}>
      {data?.length > 0 &&
        data.map((item: any, index: number) => (
          <CardItem
            key={index}
            item={item}
            index={index}
            itemsStyle={itemsStyle ? itemsStyle : {}}
            titleStyle={titleStyle ? titleStyle : {}}
            {...itemProps}
            viewed={viewed}
            updateViewStatus={(id) => {
              updateViewStatus([...viewed, id]);
            }}
          />
        ))}
    </div>
  );
};
export default memo(MenuList);
